{
  "polygons": [
    [
      {
        "latitude": 45.4598161640063,
        "longitude": -73.6391675956252
      },
      {
        "latitude": 45.4597248471938,
        "longitude": -73.6392438574883
      },
      {
        "latitude": 45.4596937556834,
        "longitude": -73.6391676852224
      },
      {
        "latitude": 45.4597849641343,
        "longitude": -73.6390916906691
      },
      {
        "latitude": 45.4598161640063,
        "longitude": -73.6391675956252
      }
    ]
  ],
  "location": {
    "latitude": 45.45976,
    "longitude": -73.6391699
  },
  "buildingCode": "BB",
  "buildingName": "BB Annex",
  "overview": [
    "Located on the Loyola Campus, the BB Annex supports campus services that enhance university life. The building is home to CPE les P’tits Profs, a childcare centre providing high-quality early childhood education to faculty, staff and student families within the Concordia community."
  ],
  "services": [
    {
      "name": "CPE Les P'tits Profs Daycare",
      "url": "https://lesptitsprofs.wordpress.com/"
    }
  ],
  "accessibility": [],
  "address": "3502 Belmore Ave.",
  "campus": "LOY",
  "url": "https://www.concordia.ca/maps/buildings/bb.html"
}